<template>
    <div class="orderPaymentMethod mtop10">
        <slot name="order_info_title"></slot>
        <div class="order_payment_method">
            <div>支付平台</div>
            <div
                class="payment_method"
                :class="{ active: payMode === 3 }"
                @click="changePay(3)"
            >
                <p></p>
                <img src="~assets/images/common/ylImg.png" alt="" />
                <span>银联支付</span>
            </div>
            <div
                class="payment_method"
                :class="{ active: payMode === 4 }"
                @click="changePay(4)"
            >
                <p></p>
                <img src="~assets/images/common/wxImg.png" alt="" />
                <span>微信支付</span>
            </div>
        </div>
        <div class="order_payment_price_box mtop40">
            <div class="order_payment_price">
                <div class="total_price">商品总额：{{ price }}</div>
                <div class="actual_price active">
                    实付款：<span>¥{{ salePrice }}</span>
                </div>
                <!-- 培训班付款状态开始 -->
                <button
                    class="orderPaymentBtn"
                    @click="firstPayment"
                    :disabled="disabled"
                    v-if="hasOrder === '0' && status != '0'"
                >
                    提交订单
                </button>
                <button
                    class="orderPaymentBtn"
                    v-if="hasOrder === '1' && status == '0'"
                    @click="firstPayment"
                >
                    继续支付
                </button>
                <!-- 培训班付款状态结束 -->
                <!-- 待支付订单 —— 付款状态开始 -->
                <button
                    class="orderPaymentBtn"
                    v-if="status === '0' && payMode !== '0'"
                    @click="unpaidPayment"
                >
                    立即支付
                </button>
                <button
                    class="orderPaymentBtn"
                    v-if="orderPayMode == '0'"
                >
                    等待确认
                </button>
                <!-- 待支付订单 —— 付款状态结束 -->
            </div>
        </div>
        <!-- 付款二维码form -->
        <form
            :action="formUrl"
            method="post"
            ref="payForm"
            id="payForm"
            class="form"
            >
            <input type="hidden" v-model="ACTION_INFO" name="ACTION_INFO" />
            <input type="hidden" v-model="ACTION_NAME" name="ACTION_NAME" />
            <input type="hidden" v-model="ACTION_SIGN" name="ACTION_SIGN" />
        </form>
    </div>
</template>

<script>
import VueEvent from '@/VueEvent.js'
import { PcCookie, Key } from "@/utils/cookie";

import { orderPay } from "api/train";
import { unpaidOrderPayment } from "api/order"

export default {
    props: {
        //订单id
        orderId:{
            type:String,
            default:''
        },
        //等待确认的订单
        orderPayMode:{
            type:String,
            default:''
        },
        //订单状态
        status:{//订单状态
            type:String,
            default:''
        },
        //是否有订单
        hasOrder: {
            type: String,
            default: "",
        },
        //培训报名id
        businessId: {
            type: String,
            default: "",
        },
        //商品金额
        price: {
            type: String,
            default: "0",
        },
        //商品实际金额
        salePrice: {
            type: String,
            default: "0",
        },
        //发票信息
        invoiceInfo: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    mounted(){
        VueEvent.$on("unpaidOrderPaymentVueEvent",() => {
            this.disabled = true;
            this.unpaidPayment();
        })
    },
    data() {
        return {
            disabled: false, //禁用开关
            businessType: "0", //0 是课程 1 是模拟 2是正式
            payMode: null, // 3 银联  4 微信
            formUrl: "https://pay.imaa.edu.cn/studentms-mobile/interface/pay_free_trans",//付款form提交地址
            ACTION_SIGN: "",
            ACTION_NAME: "",
            ACTION_INFO: "",
        };
    },
    methods: {
        //待支付订单 -- 付款
        unpaidPayment(){
            if (this.payMode == null) {
                this.$message({
                    message: "请选择付款方式！",
                    type: "warning",
                });
                VueEvent.$emit('unpaidOrderPaymentFail');
            } else {
                this.disabled = true;
                const sessionId = PcCookie.get(Key.jsessIdKey);
                unpaidOrderPayment(sessionId,this.orderId,this.payMode,this.invoiceInfo).then(res => {
                    if (res.errorCode === "2000") {
                        this.ACTION_SIGN = res.body.data.ACTION_SIGN;
                        this.ACTION_NAME = res.body.data.ACTION_NAME;
                        this.ACTION_INFO = res.body.data.ACTION_INFO;
                        setTimeout(function () {
                            document.getElementById("payForm").submit();
                        }, 2000);
                    }else{
                        this.$message.error(res.msg);
                        VueEvent.$emit('unpaidOrderPaymentFail');
                    }
                })
            }
        },
        //购买培训班--第一次下订单
        firstPayment() {
            if (this.payMode == null) {
                this.$message({
                    message: "请选择付款方式！",
                    type: "warning",
                });
            } else {
                this.disabled = true;
                const sessionId = PcCookie.get(Key.jsessIdKey);
                orderPay(
                    sessionId,
                    this.businessId,
                    this.businessType,
                    this.payMode,
                    this.invoiceInfo
                ).then((res) => {
                    if (res.errorCode === "2000") {
                        this.ACTION_SIGN = res.body.data.ACTION_SIGN;
                        this.ACTION_NAME = res.body.data.ACTION_NAME;
                        this.ACTION_INFO = res.body.data.ACTION_INFO;
                        if(res.body.data.orderInfo.status == '3'){//0元
                            this.$router.push('/pcViews/order-result')
                        }else{//不是0元
                            setTimeout(function () {
                                document.getElementById("payForm").submit();
                            }, 2000);
                        }

                    }else{
                        this.$message.error(res.msg);
                        this.disabled = false;
                    }
                });
            }
        },
        //切换支付方式
        changePay(num) {
            this.payMode = num;
        },
    },
};
</script>

<style lang="less" scoped>
.order_payment_price {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 124px;
    width: 226px;
    .total_price {
        font-size: 16px;
        color: #3b3b3b;
        line-height: 24px;
    }
    .actual_price {
        font-size: 16px;
        line-height: 34px;
        span {
            font-size: 24px;
            font-weight: bold;
        }
    }
    .actual_price.active {
        color: #ffaa15;
        span {
            color: #ffaa15;
        }
    }
    .orderPaymentBtn {
        width: 100%;
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-size: 18px;
        color: #fff;
        border-radius: 20px;
        cursor: pointer;
        background: #ffaa15;
        outline: none;
        border: 0;
    }
}
.order_payment_price_box {
    display: flex;
    justify-content: flex-end;
    height: 124px;
}
.order_payment_method {
    padding: 0 22px;
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 126px;
    font-size: 14px;
    color: #3b3b3b;
    div {
        margin-right: 13px;
    }
    > .payment_method {
        margin: 0 13px;
        width: 226px;
        height: 64px;
        border: solid 1px #dadada;
        border-radius: 3px;
        background: #fff;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        box-shadow: 0 0 6px 1px #ecedf1;
        > p {
            box-sizing: content-box;
            width: 6px;
            height: 6px;
            border: solid 5px #eaf0ee;
            background: #eaf0ee;
            border-radius: 50%;
        }
        > img {
            margin: 0 5px 0 13px;
        }
    }
    > .payment_method.active {
        border: solid 2px #ffaa15;
        p {
            background: #fff;
            border-color: #ffaa15 !important;
        }
    }
}
.order_info_title {
    padding: 0 2px;
    height: 26px;
    border-bottom: solid 1px #dadada;
    font-family: "微软雅黑";
    display: flex;
    flex-direction: row;
    align-items: center;
    > p {
        font-size: 16px;
        font-weight: bold;
        color: #000;
    }
    > span {
        margin: 0 4px;
        font-size: 12px;
        color: #818181;
    }
}
</style>
